// Compiled at 2026-05-13T13:50:05.286Z
import { System } from "../../Module/$modules.js";
import { addQueryParametersToUrl } from "@lg/shared";
import * as Common from "./Common.js";
import * as This from "./Common.js";
import { ScreenDefinition } from "@lg/shared";
import { Tasks } from "../../Screen/Common/Tasks.js";
import { SideMenu } from "../../Screen/Common/SideMenu.js";
import { PlaceholderTask } from "../../Screen/Common/PlaceholderTask.js";
import { MainLayout } from "../../Screen/Common/MainLayout.js";
import { Logo } from "../../Screen/Common/Logo.js";
import { FancyLayout } from "../../Screen/Common/FancyLayout.js";
import { FrontendScreenBridge } from "@lg/ng-shared";

// Auto-generated by Lowgile
export const $ModuleId = 'Common.js';

export * from "../../Entity/Common/UserAndName.js";
export * from "../../Entity/Common/MultiFactorAuthentication.js";
export * from "../../Entity/Common/Foo.js";
export * from "../../Label/Common/$translations.js";
export * from "../../Resource/Common/$resources.js";
export { $Config } from "../../ConfigurationItem/Common/config.js";
export * as $Process from "../../Process/Common/$processes.js";
export * from "../../Role/Common/$roles.js";
export * from "../../Permission/Common/$permissions.js";

export const $Screens = {
    Tasks: {
        moduleId: 'Common', boId: 'Tasks', component: Tasks, getFullUrl(params) {
            return addQueryParametersToUrl('/Llama/Common.Tasks', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    SideMenu: {
        moduleId: 'Common', boId: 'SideMenu', component: SideMenu, getFullUrl(params) {
            return addQueryParametersToUrl('/Llama/Common.SideMenu', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    PlaceholderTask: {
        moduleId: 'Common', boId: 'PlaceholderTask', component: PlaceholderTask, getFullUrl(params) {
            return addQueryParametersToUrl('/Llama/Common.PlaceholderTask', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    MainLayout: {
        moduleId: 'Common', boId: 'MainLayout', component: MainLayout, getFullUrl(params) {
            return addQueryParametersToUrl('/Llama/Common.MainLayout', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    Logo: {
        moduleId: 'Common', boId: 'Logo', component: Logo, getFullUrl(params) {
            return addQueryParametersToUrl('/Llama/Common.Logo', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
    FancyLayout: {
        moduleId: 'Common', boId: 'FancyLayout', component: FancyLayout, getFullUrl(params) {
            return addQueryParametersToUrl('/Llama/Common.FancyLayout', params, System.$Config.Environment.publicUrl)
        }, openAsDialog(inputData, outputName, options) { return FrontendScreenBridge.openDialogAndGetResponse(this, inputData, outputName, options) },
    } as ScreenDefinition<{
    }, {
        }, {
        }>,
};
